export class EventEmitter {
    constructor() {
        this.events = {};
    }
    subscribe(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        this.events[eventName].push(callback);
    }
    unsubscribe(eventName, callback) {
        var _a;
        if (this.events[eventName]) {
            this.events[eventName] = (_a = this.events[eventName]) === null || _a === void 0 ? void 0 : _a.filter((cb) => cb !== callback);
        }
    }
    emit(eventName, payload) {
        var _a;
        (_a = this.events[eventName]) === null || _a === void 0 ? void 0 : _a.forEach((callback) => callback({ type: eventName, payload }));
    }
}
